// Values match Firebase provider IDs and Flutter's LoginProvider.rawValue
export enum LoginProvider {
  google = 'google.com',
  apple = 'apple.com',
  email = 'password',
}

export function loginProviderFromFirebaseId(providerId: string): LoginProvider | null {
  switch (providerId) {
    case 'google.com':
      return LoginProvider.google;
    case 'apple.com':
      return LoginProvider.apple;
    case 'password':
      return LoginProvider.email;
    default:
      return null;
  }
}
